import { Tooltip, Typography as T } from "@mui/material";
import { colors } from "../styles";
import { CONTACT_SUPPORT_MSG } from "../helpers/content";

export const ErrorPage = ({ message }: { message?: string }) => {
  return (
    <div className="flex flex-col items-center justify-center w-100">
      <div className="w-50">
        {message ? (
          message
        ) : (
          <>
            <T variant="lgReg" color={colors.red}>
              Unable to load data. If it continues, please{" "}
              <Tooltip title={CONTACT_SUPPORT_MSG} arrow>
                <span className="link">contact support.</span>
              </Tooltip>
            </T>
          </>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
